export { default as SimulatorScreen } from "./SimulatorScreen";
